class ProductBadge extends HTMLElement {
  constructor() {
    super();
    this._resizeObserver = null;
    this.scale = parseFloat(this.dataset.scale) || 0.22;
    this.longestWord = parseInt(this.dataset.longestWord || "0", 10);

    document.addEventListener('discount:update', () => this.init());
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Find inner text container
    this.textEl = this.querySelector('.product-item__sale-badge--text');
    if (!this.textEl) return;

    // Resize Observer runs only on this element → very efficient
    this._resizeObserver = new ResizeObserver(() => {
      this.updateFontSize();
    });

    this._resizeObserver.observe(this);

    // Initial calculation
    this.updateFontSize();
  }

  updateFontSize() {
    const width = this.clientWidth;

    if (!width) return;

    // ---- SCALING LOGIC ----
    // Adjust coefficient to match desired look
    let fontSize = width * this.scale; // 22% of badge width
    fontSize = this.adjustFontSizeForLongWords(fontSize);
    this.textEl.style.fontSize = `${fontSize}px`;
  }
  adjustFontSizeForLongWords(fontSize) {
    if (this.longestWord > 5) {
      const extra = this.longestWord - 3;
      fontSize -= extra;
      if (fontSize < 7) {
        fontSize += 2;
      }
    }
    return fontSize > 3 ? fontSize : 3;
  }

  disconnectedCallback() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  }
}

customElements.define('product-badge', ProductBadge);